import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useApp } from '../../context/AppContext';
import Sidebar from './Sidebar';
import Header from './Header';
import MobileMenu from './MobileMenu';
import Footer from './Footer';
import { USER_ROLES } from '../../utils/constants';

const Layout = ({ children }) => {
  const { user } = useAuth();
  const { isMobile } = useApp();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);

  // Don't show sidebar for cleaning staff
  if (user?.role === USER_ROLES.CLEANING_STAFF) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col">
        {/* <Header
          // onMenuClick={() => setSidebarOpen(!sidebarOpen)}
          showMenuButton={false}
        /> */}
        <main className="flex-grow">
          {children}
        </main>
        <Footer />
        {sidebarOpen && (
          <MobileMenu
            isOpen={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
          />
        )}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile sidebar overlay */}
      {isMobile && sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        onCollapseChange={setSidebarCollapsed}
      />

      {/* Main content */}
      <div
        className={`min-h-screen flex flex-col transition-all duration-300 ${
          isMobile
            ? ''
            : sidebarCollapsed
              ? 'lg:pl-20'
              : 'lg:pl-64'
        }`}
      >
        <Header
          onMenuClick={() => setSidebarOpen(!sidebarOpen)}
          showMenuButton={isMobile}
        />

        <main className="flex-grow py-6 px-4 sm:px-6 lg:px-8">
          {children}
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default Layout;